import { render, staticRenderFns } from "./siteTop.vue?vue&type=template&id=16207234&scoped=true&"
import script from "./siteTop.vue?vue&type=script&lang=js&"
export * from "./siteTop.vue?vue&type=script&lang=js&"
import style0 from "./siteTop.vue?vue&type=style&index=0&id=16207234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16207234",
  null
  
)

export default component.exports